import styled from 'styled-components';

export const DWTCVirtualAssetsApplicationWrapper = styled.section`
  background-color: #ebebeb;
  padding-top: 100px;
  padding-bottom: 100px;
  @media (max-width: 992px) {
    padding-top: 50px;
    padding-bottom: 50px;
  }
`;
export const DWTCVirtualAssetsApplicationContainer = styled.div`
  max-width: 1121px;
  position: relative;
  margin: 0px auto;
  @media (max-width: 1199px) {
    max-width: 100%;
    padding: 0px 15px;
  }
`;
export const DWTCVirtualAssetsApplicationTitle = styled.h2`
  font-size: 30px;
  line-height: 50px;
  color: #000;
  text-align: center;
  margin: 0px;
  @media (max-width: 1199px) {
    font-size: 26px;
    line-height: 30px;
  }
  @media (max-width: 992px) {
    &[dir='ltr'] {
      text-align: left;
    }
    &[dir='rtl'] {
      text-align: right;
    }
  }
  @media (max-width: 767.98px) {
    font-size: 16px;
    line-height: 16px;
  }
`;
export const DWTCVirtualAssetsApplicationBody = styled.div`
  padding-top: 50px;
  display: flex;
  flex-direction: row;
  column-gap: 46px;
  align-items: center;
  @media (max-width: 1199px) {
    column-gap: 30px;
  }
  @media (max-width: 992px) {
    flex-direction: column;
    row-gap: 30px;
    padding-top: 25px;
    align-items: start;
  }
  @media (max-width: 767px) {
    padding-top: 20px;
  }
`;
export const DWTCVirtualAssetsApplicaitonTextWrapper = styled.div`
  max-width: 593px;
  .description {
    width: 544px;
    font-size: 14px;
    margin: 0px;
    line-height: 20px;
    color: #898989;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    row-gap: 32px;
    p {
      padding: 0px !important;
      margin: 0px !important;
    }
    @media (max-width: 992px) {
      width: 100%;
      row-gap: 15px;
    }
  }
  @media (max-width: 992px) {
    max-width: 100%;
  }
`;
export const DWTCVirturalAssetsApplicationListWrapper = styled.div``;
export const DWTCVirtualAssetsApplicationsUlList = styled.ul`
  padding-top: 28px !important;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  margin: 0px;
  padding: 0px;
  width: 544px;
  @media (max-width: 992px) {
    width: 100%;
    padding-top: 12px !important;
  }
  @media (max-width: 557px) {
    row-gap: 10px;
  }
`;
export const DWTCVirtualAssetsApplicationsLiList = styled.li`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #000;
  list-style: none;
  display: flex;
  flex-direction: row;
  column-gap: 21px;
  row-gap: 20px;
  @media (max-width: 767px) {
    column-gap: 10px;
    row-gap: 10px;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;
export const DWTCVirtualAssetsApplicationsButtonTitle = styled.p`
  padding-top: 40px;
  width: 443px;
  @media (max-width: 992px) {
    padding-top: 20px;
    width: 100%;
  }
`;
export const DWTCVirtualAssetsApplicationButtons = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 24px;
  padding-top: 40px;
  flex-wrap: wrap;
  row-gap: 15px;
  @media (max-width: 992px) {
    padding-top: 20px;
  }
  @media (max-width: 557px) {
    a {
      width: 100%;
    }
  }
`;
export const DWTCVirtualAssetsApplicationsDisclaimer = styled.p`
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: #000;
  padding-top: 16px;
  letter-spacing: 1px;
  &[dir='ltr'] {
    padding-left: 30px;
  }
  &[dir='rtl'] {
    padding-right: 30px;
  }
  @media (max-width: 992px) {
    &[dir='ltr'] {
      padding-left: 10px;
    }
    &[dir='rtl'] {
      padding-right: 10px;
    }
  }
`;
export const DWTCVirtualAssetsApplicationImage = styled.div`
  max-width: 517px;
  @media (max-width: 992px) {
    max-width: 100%;
  }
  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
`;
